import React, { Component } from 'react';
import { ButtonToolbar, Button, Form, FormGroup, ControlLabel, Checkbox, FormControl } from 'react-bootstrap';
import { SetOfDayTypesCommand } from '../../commands/SetOfDayTypesCommand';
import { HandleMessage } from '../../../HandleMessage';
import { LoadingSpinner } from '../../../LoadingSpinner';
import Select from "react-select";

export class DayTimesheetDataIdentifier extends Component {
    constructor(props) {
        super(props);

        let stopsListConfiguration = {
            show: false,
            id: props.selectedData || null,
            isDescriptionVerticalOrientation: false,
            showDescription: true,
            showZebraStripes: false,
            descriptionPt: "",
            descriptionEn: "",
            numberColumns: 20,
            startingHour: undefined,
        };

        try {
            const parsedConfig = JSON.parse(props.configuration);
            stopsListConfiguration = Object.assign(stopsListConfiguration, parsedConfig);
        } catch (error) {
        }

        this.state = {
            selectedData: props.selectedData,
            table: {
                data: [],
                loading: true,
            },
            message: {
                show: false,
                title: undefined,
                message: undefined,
                style: undefined,
                icon: undefined,
            },
            form: {
                show: stopsListConfiguration.show,
                id: stopsListConfiguration.id,
                isDescriptionVerticalOrientation: stopsListConfiguration.isDescriptionVerticalOrientation,
                showDescription: stopsListConfiguration.showDescription,
                showZebraStripes: stopsListConfiguration.showZebraStripes,
                descriptionPt: stopsListConfiguration.descriptionPt,
                descriptionEn: stopsListConfiguration.descriptionEn,
                numberColumns: stopsListConfiguration.numberColumns,
                startingHour: stopsListConfiguration.startingHour,
            },
            actions: {
                isLoading: true,
            }
        };

        this.getAllData(false);
    }

    getAllData(resetData) {
        if (resetData) {
            const { actions } = this.state;

            actions.isLoading = true;

            this.setState({
                table: {
                    data: [],
                    page: 1,
                    elementsPerPage: 10
                },
                actions: actions
            });
        }

        const setOfDayTypesCommand = new SetOfDayTypesCommand();
        setOfDayTypesCommand.list(
            (a) => this.successCallback(a),
            (a) => this.errorCallback(a)
        );
    }

    // ---------------------------

    successCallback(result) {
        const { table, actions, form } = this.state;
        const config = result && result.configuration ? JSON.parse(result.configuration) : {};

        actions.isLoading = false;
        table.data = result;

        form.id = result.dataIdentifyer || form.id;
        form.showDescription = config.showDescription !== undefined ? config.showDescription : form.showDescription;
        form.isDescriptionVerticalOrientation = config.isDescriptionVerticalOrientation !== undefined
            ? config.isDescriptionVerticalOrientation
            : form.isDescriptionVerticalOrientation;
        form.showZebraStripes = config.showZebraStripes !== undefined ? config.showZebraStripes : form.showZebraStripes;
        form.descriptionPt = config.descriptionPt !== undefined ? config.descriptionPt : form.descriptionPt;
        form.descriptionEn = config.descriptionEn !== undefined ? config.descriptionEn : form.descriptionEn;
        form.numberColumns = config.numberColumns !== undefined ? Number(config.numberColumns) : form.numberColumns;
        form.startingHour = config.startingHour !== undefined ? Number(config.startingHour) : form.startingHour;

        this.setState({
            table,
            actions,
            form
        });
    }

    errorCallback(message) {
        const { table, actions } = this.state;

        actions.isLoading = false;
        table.data = [];

        this.setState({
            table: table,
            actions: actions,
            message: {
                show: true,
                message: message,
                style: "danger",
                title: "Erro",
                icon: "remove"
            }
        });
    }

    // -----------------------

    onSelectData(selectedData) {
        const form = this.state;
        form.id = selectedData.value;

        this.setState({
            form,
            selectedData
        });
    }

    onChangeCheckboxValue(target) {
        const { form } = this.state;

        form[target] = !form[target];

        this.setState({
            form: form
        });
    }

    onChangeValue(selectedData, target) {
        const { form } = this.state;

        if (selectedData) {
            form[target] = selectedData.value; 
        } else {
            form[target] = null;
        }

        this.setState({
            form: form
        });
    }

    onFinishSelectData() {
        const { form } = this.state;
        const data = form.id;

        const configuration = {
            showDescription: form.showDescription,
            isDescriptionVerticalOrientation: form.isDescriptionVerticalOrientation,
            showZebraStripes: form.showZebraStripes,
            descriptionPt: form.descriptionPt,
            descriptionEn: form.descriptionEn,
            numberColumns: form.numberColumns,
            startingHour: form.startingHour,
        };

        // Trigger save actions
        this.props.onSelectData(data);
        this.props.onConfigureData(JSON.stringify(configuration), true);

        this.setState({
            selectedData: null,
            form: {
                show: false,
                id: null,
                isDescriptionVerticalOrientation: false,
                showDescription: true,
                showZebraStripes: false,
                descriptionPt: "",
                descriptionEn: "",
                numberColumns: 20,
                startingHour: undefined,
            },
            styles: {},
        });
    }

    onCancelSelectData() {
        this.setState({
            form: {
                show: false,
                id: 0,
                isDescriptionVerticalOrientation: false,
                showDescription: true,
                showZebraStripes: false,
                descriptionPt: "",
                descriptionEn: "",
                numberColumns: 20
            }
        });
    }

    // -----------------------

    onExitMessage() {
        this.setState({
            message: {
                show: false,
                title: undefined,
                message: undefined,
                style: undefined,
                icon: undefined
            }
        });
    }

    // -----------------------

    renderSelectedDataDescriptionPt(obj) {
        const { selectedData } = this.state;

        if (null === selectedData || undefined === selectedData) {
            return (
                <div>&nbsp;</div>
            );
        }

        const splitedData = `${selectedData}`.split("|%|");

        if (`${obj.id}` === splitedData[0] && undefined !== splitedData[1]) {
            return (
                <div>{JSON.parse(splitedData[1]).descriptionPt}</div>
            );
        }
        else {
            return (
                <div>&nbsp;</div>
            );
        }
    }

    renderSelectedDataDescriptionEn(obj) {
        const { selectedData } = this.state;

        if (null === selectedData || undefined === selectedData) {
            return (
                <div>&nbsp;</div>
            );
        }

        const splitedData = `${selectedData}`.split("|%|");

        if (`${obj.id}` === splitedData[0] && undefined !== splitedData[1]) {
            return (
                <div>{JSON.parse(splitedData[1]).descriptionEn}</div>
            );
        }
        else {
            return (
                <div>&nbsp;</div>
            );
        }
    }

    renderSetsOfDayTypes(isLoading, partialData) {
        const options = partialData.map((obj) => ({
            value: obj.id,
            label: obj.name,
        }));

        const { form } = this.state;

        const selectedOption = options.find(option => option.value === Number(form.id));

        return (
            <div>
                <FormGroup controlId="formSetOfDayTypeText">
                    <ControlLabel>Conjunto Tipo de Dia</ControlLabel>
                    {isLoading ? (
                        <LoadingSpinner />
                    ) : (
                        <Select
                            options={options}
                            placeholder="Conjunto tipo de dia"
                            value={selectedOption}
                            onChange={(e) => this.onChangeValue(e, 'id')}
                            isClearable
                            isSearchable
                        />
                    )}
                </FormGroup>
            </div>
        );
    }

    handleFormFieldChange(field) {
        return (e) => {
            const value = e.target.type === "number" ? Number(e.target.value) : e.target.value;
            const updatedForm = this.state.form;
            updatedForm[field] = value;
            this.setState({ form: updatedForm });
        };
    }

    renderTextInput(label, placeholder, value, controlId, onChange) {
        return (
            <FormGroup controlId={controlId}>
                <ControlLabel>{label}</ControlLabel>
                <FormControl
                    type="text"
                    placeholder={placeholder}
                    value={value}
                    onChange={onChange}
                />
            </FormGroup>
        );
    }

    renderNumberInput(label, placeholder, value, controlId, min, max, onChange) {
        return (
            <FormGroup controlId={controlId}>
                <ControlLabel>{label}</ControlLabel>
                <FormControl
                    type="number"
                    min={min}
                    max={max}
                    placeholder={placeholder}
                    value={value}
                    onChange={onChange}
                />
            </FormGroup>
        );
    }

    renderCheckbox(label, value, onChange, disabled = false, style = {}) {
        return (
            <Checkbox
                checked={value}
                onChange={onChange}
                disabled={disabled}
                style={style}
            >
                {label}
            </Checkbox>
        );
    }

    render() {
        const { form, message, isLoading, table } = this.state;

        return (
            <div>
                <Form>
                    {this.renderSetsOfDayTypes(
                        isLoading,
                        table.data
                    )}

                    {this.renderTextInput(
                        "Descrição PT",
                        "Descrição PT",
                        form.descriptionPt,
                        "formDescriptionPtText",
                        this.handleFormFieldChange("descriptionPt")
                    )}

                    {this.renderTextInput(
                        "Descrição EN",
                        "Descrição EN",
                        form.descriptionEn,
                        "formDescriptionEnText",
                        this.handleFormFieldChange("descriptionEn")
                    )}

                    <FormGroup>
                        {this.renderCheckbox(
                            "Apresentar Descrição",
                            form.showDescription,
                            () => this.onChangeCheckboxValue("showDescription")
                        )}

                        {this.renderCheckbox(
                            "Orientação: Vertical",
                            form.isDescriptionVerticalOrientation,
                            () => this.onChangeCheckboxValue("isDescriptionVerticalOrientation"),
                            !form.showDescription,
                            { marginLeft: "20px" }
                        )}

                        {this.renderCheckbox(
                            "Apresentar Zebras Alternadas",
                            form.showZebraStripes,
                            () => this.onChangeCheckboxValue("showZebraStripes")
                        )}
                    </FormGroup>

                    {this.renderNumberInput(
                        "Número Colunas a Apresentar [1..36]",
                        "Número Colunas a Apresentar",
                        form.numberColumns,
                        "formNumberColumnsText",
                        1,
                        36,
                        this.handleFormFieldChange("numberColumns")
                    )}

                    {this.renderNumberInput(
                        "Primeira Hora a Apresentar [0..23]",
                        "Primeira Hora a Apresentar",
                        form.startingHour,
                        "formStartingHourText",
                        0,
                        23,
                        this.handleFormFieldChange("startingHour")
                    )}
                </Form>

                <ButtonToolbar>
                    <Button bsStyle="default" onClick={() => this.onFinishSelectData()}>GUARDAR</Button>
                    <Button bsStyle="default" onClick={() => this.props.onCancel()}>FECHAR</Button>
                </ButtonToolbar>

                <HandleMessage
                    show={message.show}
                    title={message.title}
                    message={message.message}
                    style={message.style}
                    icon={message.icon}
                    onHide={this.onExitMessage}
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/bussched/layoutConfigurations/dataIdentifiers/DayTimesheetDataIdentifier.js